var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuAccountIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4117 6.07571C14.4117 8.52324 12.4493 10.4858 10 10.4858C7.55162 10.4858 5.58839 8.52324 5.58839 6.07571C5.58839 3.62819 7.55162 1.6665 10 1.6665C12.4493 1.6665 14.4117 3.62819 14.4117 6.07571ZM10 18.3332C6.38535 18.3332 3.33337 17.7457 3.33337 15.479C3.33337 13.2115 6.40453 12.6448 10 12.6448C13.6156 12.6448 16.6667 13.2323 16.6667 15.499C16.6667 17.7665 13.5956 18.3332 10 18.3332Z",
    fill: "#00609B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAccountIcon);
export default __webpack_public_path__ + "static/media/Menu-AccountIcon.42e357bea12fb5a3195da16e508fc940.svg";
export { ForwardRef as ReactComponent };